import React from 'react'

const Delivered = ({ color = '#4E60FF' }: { color?: string }) => {
  return (
    <svg
      width='101'
      height='100'
      viewBox='0 0 101 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M98.5 50C98.5 76.5097 77.0097 98 50.5 98C23.9903 98 2.5 76.5097 2.5 50C2.5 23.4903 23.9903 2 50.5 2C58.0309 2 65.1568 3.73434 71.5 6.8254M89.5 20L47.5 62L35.5 50'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Delivered
